import React, {useEffect, useState} from 'react';
import {Button, Col, Flex, Form, Input, InputNumber, Popover, Row, Select, Steps, StepsProps, Switch} from "antd";
import Header from "../../components/header/Header";
import BackGroundLogo from "../../components/adBackGroundLogo/BackGroundLogo";
import { GuaranteeCard} from "../../components";
import {useForm} from "antd/es/form/Form";
import {useLocation, useNavigate} from "react-router-dom";
import PriceCard from "../../components/priceCard/PriceCard";
import style from "./AInsertStepTow.module.scss"
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import PropertiesCard from "../../components/propertiesCard/PropertiesCard";
import ConditionsCard from "../../components/conditionsCard/ConditionsCard";
import {registerProduct} from "../../actions/AdInsert.action";
import {AdInsertStepTwoProps} from "../../models";
import {StyledSteps} from "../AdInsertSteps.styled";
import { motion, AnimatePresence, Variants } from "framer-motion";

const AdInsertStepTwo = ({registerProduct}:AdInsertStepTwoProps) => {
    const [form] = useForm();
    const [price, setPrice] = useState<any[]>([])
    const [GuaranteeCards, setGuaranteeCard] = useState()
    const [PropertiesCards, setPropertiesCard] = useState()
    const [advanced, setAdvanced] = useState<boolean>(false)
    const [direction, setDirection] = useState<1 | -1>(1);

    const [ConditionsCards, setConditionsCard] = useState()
    const onFinish = (value: any) => {
        value= location.state.stepOneForm
        value.ownerId= "7a36ceff-4848-4448-baf2-4d2a6c328a68"
        value.productAssurances = advanced ? GuaranteeCards : []
        value.productConditions = advanced ? ConditionsCards : []
        value.productPricings =advanced ? price : price.filter((i:any) => i?.pricingMethodId === 1)
        value.productProperties =PropertiesCards
        value.productImages =[]
        value.advanced =advanced
        navigate('/ad-insert-step-three',{state:{
                stepTwoForm:value,stepOneForm:location.state.stepOneForm,uploadedImages:location.state.uploadedImages
            }})

    }
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (location.state?.stepTwoForm){
            setPrice(location.state?.stepTwoForm?.productPricings);
            setGuaranteeCard(location.state?.stepTwoForm?.productAssurances);
            setPropertiesCard(location.state?.stepTwoForm?.productProperties);
            setConditionsCard(location.state?.stepTwoForm?.productConditions);
            setAdvanced(location.state?.stepTwoForm?.advanced);
        }
    }, [location]);

    const containerVariants: Variants = {
        hidden: {
            opacity: 1,
        },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.12,
                delayChildren: 0.1,
            },
        },
        exit: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                staggerDirection: -1, // exit one-by-one (reverse)
            },
        },
    };

    const itemVariants: Variants = {
        hidden: (direction: number) => ({
            opacity: 0,
            x: direction * 60,
        }),
        show: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.3,
                ease: "easeOut",
            },
        },
        exit: (direction: number) => ({
            opacity: 0,
            x: -direction * 60,
            transition: {
                duration: 0.2,
                ease: "easeIn",
            },
        }),
    };
    return (
        <Flex vertical gap={"small"}>
            <Header step={2}/>
            <BackGroundLogo step={2}/>
               <Flex vertical gap={"small"}>
                   <Row justify={"end"}>
                       <Switch
                           checked={advanced}
                           onChange={(checked) => {
                               setDirection(checked ? 1 : -1);
                               setAdvanced(checked);
                           }}
                           checkedChildren="پیشرفته"
                           unCheckedChildren="پیشرفته"
                       />
                   </Row>
                   <AnimatePresence mode="wait" custom={direction}>
                       {advanced ? (

                               <motion.div
                                   key="advanced"
                                   variants={containerVariants}
                                   initial="hidden"
                                   animate="show"
                                   exit="exit"
                               >
                                   <Flex vertical gap={"small"}>
                                   <motion.div variants={itemVariants} custom={direction}>
                                       <PriceCard onConfirm={setPrice}/>
                                   </motion.div>

                                   <motion.div variants={itemVariants} custom={direction}>
                                       <GuaranteeCard onConfirm={setGuaranteeCard}/>
                                   </motion.div>

                                   <motion.div variants={itemVariants} custom={direction}>
                                       <PropertiesCard onConfirm={setPropertiesCard}/>
                                   </motion.div>

                                   <motion.div variants={itemVariants} custom={direction}>
                                       <ConditionsCard onConfirm={setConditionsCard}/>
                                   </motion.div>
                                   </Flex>
                               </motion.div>


                       ) : (
                           <motion.div
                               key="basic"
                               variants={containerVariants}
                               initial="hidden"
                               animate="show"
                               exit="exit"
                           >
                               <Flex vertical gap={"small"}>
                               <motion.div variants={itemVariants} custom={direction}>
                                   <InputNumber<number>
                                       value={!!price.length && price?.find((i:any) => i?.pricingMethodId === 1 )?.price}
                                       onChange={(value: any) => setPrice([{price: value, pricingMethodId: 1, label: 'ساعتی'}])}
                                       placeholder={'قیمت روزانه'}
                                       size={"large"}
                                       style={{width: "100%"}}
                                       formatter={(value) =>
                                           `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                       }
                                       parser={(value) =>
                                           value?.replace(/\$\s?|(,*)/g, "") as unknown as number
                                       }
                                       suffix={"تومان"}
                                   />
                               </motion.div>

                               <motion.div variants={itemVariants} custom={direction}>
                                   <PropertiesCard onConfirm={setPropertiesCard}/>
                               </motion.div>
                               </Flex>
                           </motion.div>
                       )}
                   </AnimatePresence>
                   <Form form={form} onFinish={onFinish}>
                   <Flex gap={"small"} className={style.customBtns}>
                           <Button htmlType={"submit"} size={"large"} type={"primary"} block> ادامه</Button>
                           <Button onClick={() => navigate('/ad-insert-step-one', {
                               state: {
                                   stepOneForm: location.state.stepOneForm,
                                   stepTwoForm:{
                                       productAssurances : GuaranteeCards,
                                       productConditions : ConditionsCards,
                                       productProperties : PropertiesCards,
                                       productPricings : price,
                                       advanced : advanced,
                                   }
                               }})} size={"large"}  block >مرحله قبل</Button>
                       </Flex>
                   </Form>
               </Flex>
        </Flex>
    );
};

export default connect(null, {registerProduct})(withRouter(AdInsertStepTwo));
